<template>
  <div class="yqgkcCon">
    <div style="height:120px;overflow:hidden;">
      <vue-seamless-scroll :data="orgIntroList"  :class-option="optionSetting">
          <p class="yqgkcCon_text" v-for="(item,index) in orgIntroList" :key="index">  
            {{item}}
          </p>
      </vue-seamless-scroll>
     </div>
    <el-carousel indicator-position="outside" height="124px">
      <el-carousel-item v-for="(group, groupIndex) in photoGroups" :key="groupIndex">
        <viewer :images="group" class="yqgkcCon_imglist" :class="{ 'two-images': group.length === 2 }">
          <img
            v-for="(img, index) in group"
            :src="urlimg+img"
            :key="index"
          />
        </viewer>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props:{
    cygkCoverValue:Object,
    urlimg:String
  },
  name: "ykgkCov",
  data(){
    return{
      photo:[],
      orgIntroList:[]
    }
  },
  computed:{
    // 将照片分成每组3张
    photoGroups() {
      const groups = [];
      for (let i = 0; i < this.photo.length; i += 3) {
        groups.push(this.photo.slice(i, i + 3));
      }
      return groups;
    },
    optionSetting(){
      return{
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        autoPlay: true, // 是否自动滚动
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  mounted(){
    this.initData();
  },
  methods: {
    initData() {
      if (this.cygkCoverValue) {
        // 处理机构介绍文本
        if (this.cygkCoverValue.orgIntro) {
          this.orgIntroList = this.cygkCoverValue.orgIntro.split('\n');
        }
        
        // 处理照片数据
        if (this.cygkCoverValue.orgPics) {
          this.photo = this.cygkCoverValue.orgPics.split(",").filter(item => item.trim() !== '');
        }
      }
    }
  },
  watch: {
    cygkCoverValue: {
      handler(newVal) {
        if (newVal) {
          this.initData();
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "@/assets/css/home.css";
.yqgkcCon_imglist{
  justify-content: flex-start; // 默认左对齐
  
  &.two-images {
    justify-content: center; // 两张图时居中对齐
  }
  
}
</style>
